/**
 * Web Notifications API helper — desktop notifications that pop up outside the browser.
 */
export function isSupported() {
  return typeof window !== "undefined" && "Notification" in window;
}

export function permission() {
  if (!isSupported()) return "denied";
  return Notification.permission;
}

export async function requestPermission() {
  if (!isSupported()) return "denied";
  if (Notification.permission === "granted" || Notification.permission === "denied") {
    return Notification.permission;
  }
  try {
    return await Notification.requestPermission();
  } catch (e) {
    return "denied";
  }
}

/**
 * Show a native OS notification. Falls back silently if not supported / not granted.
 * @param {string} title
 * @param {object} opts { body, tag, url, icon }
 */
export function notify(title, opts = {}) {
  if (!isSupported() || Notification.permission !== "granted") return null;
  try {
    const n = new Notification(title, {
      body: opts.body,
      tag: opts.tag,
      icon: opts.icon || "/logo192.png",
      badge: opts.icon || "/logo192.png",
      silent: false,
      requireInteraction: !!opts.requireInteraction,
    });
    if (opts.url) {
      n.onclick = () => {
        window.focus();
        try { window.location.href = opts.url; } catch (_) { /* ignore */ }
        n.close();
      };
    }
    // Auto-close after 5 seconds unless requireInteraction
    if (!opts.requireInteraction) {
      setTimeout(() => { try { n.close(); } catch (_) { /* ignore */ } }, 5000);
    }
    return n;
  } catch (e) {
    return null;
  }
}
